module.exports = __webpack_public_path__ + "img/comm-04-press-bg-01.f97c9d36.jpg";